import React from 'react';

interface FavoriteIconProps {
  color: string;
  isActive?: boolean;
  size?: number;
}

export const FavoriteIcon: React.FC<FavoriteIconProps> = ({
  color,
  isActive = false,
  size = 24,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5003 12.572L12.0003 20L4.5003 12.572C4.00561 12.0906 3.61594 11.512 3.35585 10.8726C3.09575 10.2333 2.97086 9.54694 2.98904 8.85693C3.00721 8.16691 3.16806 7.48813 3.46146 6.86333C3.75485 6.23853 4.17444 5.68125 4.69379 5.22657C5.21314 4.7719 5.82101 4.42968 6.47911 4.22147C7.13722 4.01327 7.83131 3.94358 8.51767 4.0168C9.20403 4.09001 9.8678 4.30455 10.4672 4.6469C11.0666 4.98925 11.5885 5.45199 12.0003 6.00599C12.4138 5.45602 12.9364 4.99731 13.5354 4.6586C14.1344 4.31988 14.7968 4.10844 15.4812 4.03751C16.1657 3.96658 16.8574 4.03769 17.5131 4.24639C18.1688 4.45508 18.7743 4.79687 19.2919 5.25036C19.8094 5.70385 20.2277 6.25928 20.5207 6.88189C20.8137 7.50449 20.975 8.18088 20.9946 8.8687C21.0142 9.55653 20.8916 10.241 20.6344 10.8792C20.3773 11.5175 19.9912 12.0958 19.5003 12.578"
        fill={isActive ? color : 'none'}
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
